export function readStored(key) {
  try { return window.localStorage.getItem(key); } catch (_) { return null; }
}

export function writeStored(key, value) {
  try { window.localStorage.setItem(key, value); } catch (_) { /* Firebase can use an in-memory session. */ }
}

export function clearSessionCache(clearEmail = false) {
  try {
    const keys = ['token', 'paymentFlag'];
    if (clearEmail) keys.push('emailForSignIn');
    keys.forEach(key => window.localStorage.removeItem(key));
  } catch (_) { /* Storage may be unavailable in private browsing. */ }
}

export function returnPath(path) {
  if (typeof path !== 'string' || !path.startsWith('/') || path.startsWith('//') || /[\\\s]/.test(path)) return '/';
  const pathname = path.split(/[?#]/)[0].replace(/\/+$/, '').toLowerCase();
  if (['/signin', '/signinemail', '/signinlink', '/signup', '/register', '/login', '/finishlogin', '/wait', '/forgotpassword', '/forgot-password', '/signin/email', '/signin/google', '/signin/link'].includes(pathname)) return '/';
  return path;
}

export function authError(error) {
  const messages = {
    'auth/popup-blocked': 'Your browser blocked the Google sign-in window. Allow pop-ups for this site, or sign in with email.',
    'auth/popup-closed-by-user': 'The Google window closed before sign-in finished. Please try again.',
    'auth/cancelled-popup-request': 'Please finish signing in using the most recent Google window.',
    'auth/unauthorized-domain': 'Sign-in is unavailable at this address. Please use options.21ifm.com or contact office@21ifm.com.',
    'auth/account-exists-with-different-credential': 'This email already has an account. Sign in using the method you originally used.',
    'auth/invalid-email': 'Please enter a valid email address.',
    'auth/wrong-password': 'The email or password is incorrect. Please try again or reset your password.',
    'auth/user-not-found': 'The email or password is incorrect. Please try again or reset your password.',
    'auth/invalid-credential': 'The email or password is incorrect. Please try again or reset your password.',
    'auth/user-disabled': 'This account is disabled. Please contact office@21ifm.com.',
    'auth/email-already-in-use': 'That email is already registered. Please sign in instead.',
    'auth/weak-password': 'Please use a password with at least six characters.',
    'auth/too-many-requests': 'There have been too many attempts. Please wait a little and try again.',
    'auth/network-request-failed': 'We could not connect. Check your internet connection and try again.',
    'auth/expired-action-code': 'This link has expired. Please request a new sign-in link.',
    'auth/invalid-action-code': 'This link is invalid or has already been used. Please request a new sign-in link.',
    'auth/operation-not-allowed': 'This sign-in method is unavailable. Please try another method or contact office@21ifm.com.',
  };
  return messages[error && error.code] || 'We could not complete that request. Please try again or contact office@21ifm.com.';
}
